module.exports = __webpack_public_path__ + "img/15.f4147f58.png";